import { apiGet, apiPut } from "./client";
import type { IntakeSourcesConfig } from "@sales-ops-amplify/shared";

export interface IntakeSourcesResponse {
  intakeSources: IntakeSourcesConfig | null;
}

export type DiscoveryProfilePatch = Partial<
  Pick<
    IntakeSourcesConfig,
    | "trackedCompanies"
    | "signalFilter"
    | "locationFilter"
    | "seniorityBoost"
    | "signalSources"
  >
>;

/** Load the user's discovery profile (tracked companies + default filters). */
export async function getDiscoveryProfile(): Promise<IntakeSourcesConfig | null> {
  const res = await apiGet<IntakeSourcesResponse>("/api/intake-sources");
  return res.intakeSources;
}

/** Save discovery profile fields (merge on server). */
export async function saveDiscoveryProfile(
  patch: DiscoveryProfilePatch,
): Promise<IntakeSourcesConfig> {
  const res = await apiPut<IntakeSourcesResponse>("/api/intake-sources", patch);
  if (!res.intakeSources) {
    throw new Error("Failed to save discovery profile");
  }
  return res.intakeSources;
}
